import usePermissions from '@/hooks/usePermissions';
import { Box, Button, useBreakpoint } from '@palmetto/palmetto-components';
import { Helmet } from 'react-helmet';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { UserPermissions } from 'types';

import { AccountsExportAction } from './AccountsExportAction';
import { AccountsSummary } from './AccountsSummary';
import { useCanPerformActionForNoNewSalesOrgStatus } from './auth/canPerformActionForNoNewSalesOrgStatus';
import { useIsOrgReadOnly } from './auth/claimsUtils';
import RequirePermissions from './auth/requirePermissions';
import { MainContainer } from './MainContainer';
import PageHeader from './PageHeader';

export function Accounts() {
  const navigate = useNavigate();
  const { isPhone } = useBreakpoint();
  const [searchParams] = useSearchParams();
  const userPermissions = usePermissions();
  const canExportAccounts =
    userPermissions.includes(UserPermissions.admin) || userPermissions.includes(UserPermissions.orgAccountingAdmin);
  const cancelled = searchParams.get('cancelled');
  const showCancelled = cancelled !== null;
  const postActivation = searchParams.get('postActivation');
  const showPostActivation = postActivation !== null;
  const allowsAction = useIsOrgReadOnly();
  const titlePrefix = showCancelled ? 'Cancelled' : showPostActivation ? 'Post-Activation' : '';
  const canPerformActionBasedOnNoNewSalesOrgStatus = useCanPerformActionForNoNewSalesOrgStatus();

  return (
    <>
      <Helmet>
        <title>{titlePrefix} Accounts</title>
      </Helmet>
      <MainContainer>
        <PageHeader title={`${titlePrefix} Accounts`}>
          <RequirePermissions
            permissions={[UserPermissions.admin, UserPermissions.editor]}
            checkAllPermissions={false}
          >
            <Box display="flex" direction="row" childGap="sm">
              <Button
                variant="primary"
                iconPrefix="add"
                size={{ base: 'sm', desktop: 'md' }}
                aria-label="create account"
                navigate={() => (allowsAction ? navigate(`/account/create`) : undefined)}
                isDisabled={!allowsAction}
                disabled={!canPerformActionBasedOnNoNewSalesOrgStatus || !allowsAction}
              >
                {!isPhone && 'Account'}
              </Button>
              {canExportAccounts && <AccountsExportAction />}
            </Box>
          </RequirePermissions>
        </PageHeader>
        <AccountsSummary />
      </MainContainer>
    </>
  );
}
